import { Input, InputProps, InputRef } from "antd";
import { forwardRef, useState } from "react";
import styles from "./style.module.scss";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

export const VLInputWithPassword = forwardRef<InputRef, InputProps>(
  ({ autoComplete = "off", ...rest }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <Input
        ref={ref}
        autoComplete={autoComplete}
        {...rest}
        type={showPassword ? "text" : "password"}
        suffix={
          <button
            type="button"
            className={styles.toggleButton}
            onClick={() => setShowPassword(!showPassword)}
            tabIndex={-1}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
          </button>
        }
      />
    );
  },
);
